import { Box } from "@mui/material";
import "./EvidenceAndLiveFeedPlayer.scss";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Tab, Tabs } from "@vds/tabs";
import { Typography } from "@vds/typography";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import VideoPlay from "../../../global/components/VideoPlay";
import { PlayHLSVideo } from "../../../global/components/VideoPlayer";
import CreateWidgetWithComponent from "../../../global/CreateWidgetWithComponent";
import StatisticsWidget from "./StatisticsWidget";
import VideoFailedComponent from "./VideoFailedComponent";
import ErrorTemplate from "../../../global/components/errorTemplate/ErrorTemplate";
import { TEXT } from "../../../global/constants/errorTemplateConstants";
import { getNotificationBannerType, getNotificationBannerTitle } from "../../../global/utility/incidentsUtils";
import { EVENTS_INFO_CONSTANTS } from "../../../global/constants/constants";

const EvidenceAndLiveFeedPlayer = ({
  state,
  socketImageEvidence,
  socketVideoEvidence,
  videoLoader,
  isImageLoading,
  evidenceImage,
  incidentId,
  activeTabIndex,
  handleTabChange,
  liveFeedPermitted,
  evidenceData,
  fieldsData,
  liveFeedStyle,
  dispatch,
  showNotificationBanner,
  cameraId,
  videoFailedComp,
  evidenceVideo,
  hasOnlyVideo,
  hasOnlyImage,
  hasVideoAndImage,
  noMedia,
  videoDownloadError,
  incidentCreatedBefore,
  onFetchFreshUrl
}) => {
  let ApplicationId = state?.applicationId;
  const knowiFullllWidgetList = useSelector((state) => state.statisticsReducer.widgets);
  const isCaptureVideoEvidence = state?.deploymentConfig?.[0].config?.["alert-parameters"]?.["ignore_video_evidence"] ?? false;
  const widgetToFilter =
    knowiFullllWidgetList?.filter((m) => {
      if (ApplicationId == "ParkingBayOccupancy") {
        return m?.name.indexOf(ApplicationId?.toLowerCase()) > -1 && m?.name.indexOf("oa_") > -1 && m?.name.indexOf("EInfo_") > -1;
      } else {
        return m?.name.indexOf(ApplicationId?.toLowerCase()) > -1 && m?.name.indexOf("EInfo_") > -1;
      }
    }) ?? [];
  if ((widgetToFilter && widgetToFilter?.length > 0) || state?.type !== "Incident" || state?.type === "SmartAlert") {
    return (
      <Box className="evidencePlayer-stats-container">
        <Grid2 className="evidencePlayer-stats-grid">
          <StatisticsWidget state={state} />
        </Grid2>
      </Box>
    );
  }

  if (
    (videoLoader && state?.type === "Incident" && state?.evidenceStatus !== 2 && state?.evidenceStatus !== 3 && !hasVideoAndImage) ||
    (state?.evidenceStatus === 1 && state?.type === "Incident" && !socketVideoEvidence && videoLoader && !hasVideoAndImage) ||
    (hasOnlyVideo && videoLoader)
  ) {
    return (
      <>
        <Box className="evidencePlayer-loading-box">
          <div className="evidencePlayer-loading-placeholder">
            <Spinner />
            <div className="evidencePlayer-loading-text">
              <div>Loading event video</div>
            </div>
          </div>
        </Box>
      </>
    );
  }

  if (
    (socketVideoEvidence || videoFailedComp || state?.evidenceStatus === 0 || state?.evidenceStatus === 1) &&
    state?.type === "Incident" &&
    state?.evidenceStatus !== 3
  ) {
    return (
      <Box className="evidencePlayer-main-container">
        <Box className="evidencePlayer-tabs-header-box">
          {" "}
          <div className="evidencePlayer-tabs-row">
            <div className="evidencePlayer-tabs-wrapper">
          <Tabs
            orientation="horizontal"
            indicatorPosition="bottom"
            selectedIndex={activeTabIndex}
            fillContainer={false}
            data-testid="eventsInfo_videoAndLiveFeedTab"
            onTabChange={handleTabChange}
          >
            <Tab label= {!isCaptureVideoEvidence ? "Video" : "Video"} />
            <Tab label="Live Feed" />
          </Tabs></div>
          {/* {incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_HOUR && incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_DAY && !hasVideoAndImage &&
           <div style={{width:"12%"}}>Request Evidence</div>}
           <Button
                             size="large"
                             use="primary"
                             data-testid="eventsInfo_requestEvidenceButton"
                             onClick={() => {
                              console.log("Request Evidence clicked");}}
                           >
                             Request Evidence
                           </Button>
           */}

          </div>
        </Box>
        

        {activeTabIndex === 0 && state?.evidenceStatus !== 3 && (
          <Grid2 className="evidencePlayer-video-grid">
            {state?.type === "Incident" && (state?.evidenceStatus === 2 || noMedia || incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MONTH) ? (
              <Box className="evidencePlayer-error-box">
                <ErrorTemplate 
                  title={getNotificationBannerTitle({incidentCreatedBefore, hasOnlyImage, noMedia, videoDownloadError, hasOnlyVideo, hasVideoAndImage, incident:state})} 
                  description={""} 
                  testId="events-live-video_player"
                  templateType={getNotificationBannerType(
                    incidentCreatedBefore,
                    hasOnlyImage,
                    noMedia,
                    videoDownloadError,
                    hasOnlyVideo,
                    hasVideoAndImage
                  )}
                />
              </Box>
            ) : (
              <VideoPlay
                evidenceUrl={evidenceVideo?.mediaUrl}
                posterImage={evidenceImage?.mediaUrl}
                evidenceId={socketVideoEvidence?.id}
                mediaId={socketVideoEvidence?.mediaId}
                mediaStartTime={socketVideoEvidence?.mediaStartTime}
                mediaEndTime={socketVideoEvidence?.mediaEndTime}
                availability={socketVideoEvidence?.mediaAvailableTill }
                hasMedia={socketVideoEvidence?.hasMedia}
                isMediaDeleted={socketVideoEvidence?.isMediaDeleted}
                sourceId={socketVideoEvidence?.sourceId}
                incidentId={incidentId}
                videoLoader={videoLoader}
                onFetchFreshUrl={onFetchFreshUrl}
                cameraId={cameraId}
                hasOnlyVideo={hasOnlyVideo}
                hasOnlyImage={hasOnlyImage}
                hasVideoAndImage={hasVideoAndImage}
                noMedia={noMedia}
                videoDownloadError={videoDownloadError}
                isCaptureVideoEvidence={isCaptureVideoEvidence}
              />
            )}
          </Grid2>
        )}

        {activeTabIndex === 1 && (
          <Grid2 className="evidencePlayer-livefeed-grid">
            {liveFeedPermitted ? (
              <>
                <CreateWidgetWithComponent
                  title=""
                  comp={
                    <PlayHLSVideo
                      isCustomWrapper={true}
                      liveFeedStyle={liveFeedStyle}
                      liveFeedStream={{
                        refidtype: "uuid",
                        id: state?.fovId ? state?.fovId : evidenceData?.fovId,
                        inputHeight: "45vh"
                      }}
                      compData={fieldsData?.location ? { state } : {}}
                    />
                  }
                />
              </>
            ) : (
              <>
                <Box className="evidencePlayer-no-livefeed-box">
                  <div className="evidencePlayer-no-livefeed-content">
                    <Typography className="evidencePlayer-no-livefeed-title">
                      Live feed is not available.
                    </Typography>
                    <Typography className="evidencePlayer-no-livefeed-message">
                      You do not have the required access to watch live feed. Please view your permissions on the users page or talk to your system
                      administrator.
                    </Typography>
                  </div>
                </Box>
              </>
            )}
          </Grid2>
        )}
      </Box>
    );
  }
};

export default EvidenceAndLiveFeedPlayer;
